"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var owa_analytics_1 = require("owa-analytics");
var owa_strings_1 = require("owa-strings");
var universalCookies_1 = require("owa-service/lib/universalCookies");
var BingNativeAdsRequestEndPointRoot = 'https://www.bing.com/api/beta/v7/ads/native/search?appid=D41D8CD98F00B204E9800998ECF8427E7BAA744C';
var BingDesktopOneClickRequestQueryStringFormat = "{'_type': 'Ads/NativeAdsRequest','imp': [{ 'id': '1232441',}],'site': {'domain': 'www.outlook.com','cat': ['oneclick'],'page': 'http://www.outlook.com/','Language':'en','Country':'us','keywords': ['.'],'publisher': {'id': '1239585','name': 'outlook','domain': 'www.outlook.com','ext': { 'apikey':'ARBDycX5PCsc2Xs2U73viCpSGX/oZemyTj6Lt6rYJFVguFcWegWxEIpShQuBJS5weu8=','tracingtag':'OutlookTest'}}}}";
var BingDesktopTwoClickRequestQueryStringFormat = "{'_type':'Ads/NativeAdsRequest','imp':[{'id':'1232441',}],'site':{'domain':'www.outlook.com','cat':['emailadsiframe'],'page':'http://www.outlook.com/','Language':'en','Country':'us','keywords':['.'],'publisher':{'id':'1239585','name':'outlook','domain':'www.outlook.com','ext':{'apikey':'ARAtr+OhzEgxbwNnPtEn3yGS2bC0eJF8Rd7N63u9DYP/KHT2ya4cWNXXMFvvDwW1A2o=','tracingtag':'OutlookTest'}}}}";
var loadBingNativeAdsDataPoint;
function fetchBingNativeAds(messageAdType, adMarket, triggerEvent) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var isOneClick, userANID, url, response, responseBody, logClientError;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    loadBingNativeAdsDataPoint = new owa_analytics_1.PerformanceDatapoint('LoadBingNativeAds');
                    isOneClick = messageAdType == "BingOneClick" /* BingOneClick */ ||
                        messageAdType == "BingOneClickOIO" /* BingOneClickOIO */;
                    userANID = universalCookies_1.getCookie('ANON');
                    loadBingNativeAdsDataPoint.addCustomData({
                        messageAdType: messageAdType,
                        userMarket: adMarket,
                        originalMessageAdType: null,
                        refreshEvent: triggerEvent,
                        anid: userANID,
                    });
                    url = owa_strings_1.format('{0}&q={1}', BingNativeAdsRequestEndPointRoot, encodeURIComponent(isOneClick
                        ? BingDesktopOneClickRequestQueryStringFormat
                        : BingDesktopTwoClickRequestQueryStringFormat));
                    return [4 /*yield*/, fetch(url, { credentials: 'include' })];
                case 1:
                    response = _a.sent();
                    if (!response.ok) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.text()];
                case 2:
                    responseBody = _a.sent();
                    return [2 /*return*/, ProcessBingAdResponse(responseBody, messageAdType, adMarket, isOneClick, triggerEvent)];
                case 3:
                    logClientError = new Error('ResponseNotOk:' + response.statusText);
                    loadBingNativeAdsDataPoint.endWithError(owa_analytics_1.DatapointStatus.ClientError, logClientError);
                    return [2 /*return*/, null];
            }
        });
    });
}
exports.default = fetchBingNativeAds;
function ProcessBingAdResponse(responseText, messageAdType, adMarket, isOneClick, triggerEvent) {
    var bingAdRawResponse;
    try {
        bingAdRawResponse = JSON.parse(responseText);
    }
    catch (error) {
        if (loadBingNativeAdsDataPoint) {
            var logClientError = new Error('ResponseParseError:' + responseText);
            loadBingNativeAdsDataPoint.endWithError(owa_analytics_1.DatapointStatus.ClientError, logClientError);
        }
        return null;
    }
    var result = [];
    var bingAd;
    if (bingAdRawResponse &&
        bingAdRawResponse.adContainers &&
        bingAdRawResponse.adContainers[0].decorations) {
        // This is the new v7 type of the Bing two-click response that we are able to retrieve the information from bingAdDecoration directly
        var bingAdDecoration = bingAdRawResponse.adContainers[0].decorations[0];
        bingAd = {
            adSender: bingAdDecoration.sender,
            adSubject: bingAdDecoration.subject,
            adPreviewTexts: bingAdDecoration.preview,
            adTextsToRenderBody: responseText,
            adType: messageAdType,
            adChoiceUrl: 'https://choice.microsoft.com',
            adMarket: adMarket,
            adRefreshEvent: triggerEvent,
            isRead: false,
        };
    }
    else if (bingAdRawResponse && bingAdRawResponse.ads) {
        // This is the old v5 style type Bing two-click or one-click response
        var bingRawAd = bingAdRawResponse.ads[0];
        bingAd = {
            adSender: NormalizeBingAdSender(bingRawAd),
            adSubject: bingRawAd.title,
            adPreviewTexts: bingRawAd.description ? bingRawAd.description : bingRawAd.title,
            adTextsToRenderBody: responseText,
            adType: messageAdType,
            adChoiceUrl: 'https://choice.microsoft.com',
            adOneClickDirectTargetUrl: isOneClick ? bingRawAd.targetUrl : null,
            adMarket: adMarket,
            adRefreshEvent: triggerEvent,
            isRead: false,
        };
        // Set the Bing OneClick Ad price value to be displayed in Outlook. There are three cases
        // 1. There is no original price or deal price, we set nothing
        // 2. There are both original price and deal price, we set original price as AdOriginalPrice (it will be cross-stroke in the subject line) and the deal price as DealPrice.
        // 3. There is only orignial price but no deal price, we set original price as the deal price for OWA to be displayed directly.
        if (bingRawAd.decorations) {
            if (bingRawAd.decorations[0].dealPrice) {
                bingAd.adCurrentPrice = bingRawAd.decorations[0].dealPrice;
                bingAd.adOriginalPrice = bingRawAd.decorations[0].originalPrice;
            }
            else {
                bingAd.adCurrentPrice = bingRawAd.decorations[0].originalPrice;
            }
        }
    }
    else {
        if (loadBingNativeAdsDataPoint) {
            var logClientError = new Error('NoValidAd:' + responseText);
            loadBingNativeAdsDataPoint.endWithError(owa_analytics_1.DatapointStatus.ClientError, logClientError);
        }
        return null;
    }
    result.push(bingAd);
    if (loadBingNativeAdsDataPoint) {
        loadBingNativeAdsDataPoint.end();
    }
    return result;
}
exports.ProcessBingAdResponse = ProcessBingAdResponse;
function NormalizeBingAdSender(bingRawAd) {
    if (bingRawAd.decorations && bingRawAd.decorations[0].sellerName) {
        // This is the product Ad that has the seller name as the sender directly
        return bingRawAd.decorations[0].sellerName;
    }
    else if (bingRawAd.displayUrl) {
        // Retrieve the root web site name and upper case the first letter
        // For example, for a url like https://www.microsoft.com/abc/def, we need Microsoft.com
        return NormalizeDisplayUrl(bingRawAd.displayUrl);
    }
    // The following code should be never hit in the real situation. We will simply set it as Ad to avoid the empty sender to guard ourselves.
    return 'Ad';
}
function NormalizeDisplayUrl(url) {
    url = url.toLowerCase();
    var urlParts;
    if (url.search(/^https?\:\/\//) != -1) {
        urlParts = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
    }
    else {
        urlParts = url.match(/^([^\/?#]+)(?:[\/?#]|$)/i);
    }
    var rootWebUrl = urlParts[1].replace(/^www\./i, '');
    return rootWebUrl.charAt(0).toUpperCase() + rootWebUrl.slice(1);
}
exports.NormalizeDisplayUrl = NormalizeDisplayUrl;
//# sourceMappingURL=fetchBingNativeAds.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/owa-mail-messagead-orchestration/lib/services/fetchBingNativeAds.js
// module id = 6011
// module chunks = 67